"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const _params_1 = require("@params");
const dateUtils_1 = require("@app/utils/dateUtils");
const common_1 = require("@components/common");
const chartsCommon_1 = require("@app/routes/Dashboard/chartsCommon");
const locale_1 = __importDefault(require("../locale"));
const useChartCustomTooltip_1 = require("@app/routes/Dashboard/hooks/useChartCustomTooltip");
const useTargetExerciseContext_1 = require("@app/routes/Dashboard/hooks/useTargetExerciseContext");
const CategoryHalfDonutsPopup_1 = __importDefault(require("@app/routes/Dashboard/components/CategoryHalfDonutsPopup"));
const ChartSelect_1 = require("@components/form/ChartSelect");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const ModulesColumns = () => {
    const [moduleKey, setModuleKey] = (0, react_1.useState)("");
    const [prgModules, setPrgModules] = (0, react_1.useState)([]);
    const { openTooltip, closeTooltip, tooltipState } = (0, useChartCustomTooltip_1.useChartCustomTooltip)({ initState: {} });
    const { setTargetExercise } = (0, useTargetExerciseContext_1.useTargetExerciseContext)();
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        // @ts-ignore
        fetch(_params_1.apiHost + `/charts/progress_modules?date_start=${filterState.fromDate}&date_end=${filterState.toDate}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json()).then(response => {
            var _a;
            setPrgModules(response);
            setModuleKey((_a = response[0]) === null || _a === void 0 ? void 0 : _a.name);
        });
    }, [filterState.fromDate, filterState.toDate]);
    const prgModulesData = moduleKey
        // @ts-ignore
        ? prgModules === null || prgModules === void 0 ? void 0 : prgModules.filter(dataset => (dataset === null || dataset === void 0 ? void 0 : dataset.name) === moduleKey)
        : prgModules;
    // @ts-ignore
    const modules = [...new Set(prgModules === null || prgModules === void 0 ? void 0 : prgModules.map(dataset => dataset === null || dataset === void 0 ? void 0 : dataset.name))];
    const prgModulesState = {
        // @ts-ignore
        series: [
            {
                data: prgModulesData.map(e => e.middle_percent),
                name: ''
            },
        ],
        options: {
            title: {
                text: locale_1.default.byPeriod,
                style: chartsCommon_1.titleStyle
            },
            chart: {
                toolbar: {
                    show: false
                },
                events: {
                    dataPointSelection: (e, chart, options) => {
                        var _a, _b, _c;
                        const { dataPointIndex } = options;
                        const { clientX, clientY } = ((_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.ctx) === null || _b === void 0 ? void 0 : _b.events.w) === null || _c === void 0 ? void 0 : _c.globals) || {};
                        openTooltip({
                            params: {
                                clientX,
                                clientY,
                                dataPointIndex
                            }
                        });
                    }
                }
            },
            responsive: [
                {
                    breakpoint: 779,
                    options: {
                        chart: {
                            width: 760
                        }
                    }
                },
                {
                    breakpoint: 400,
                    options: {
                        chart: {
                            width: 350
                        }
                    }
                }
            ],
            colors: ['#B089FF'],
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded',
                    borderRadius: 2,
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 5,
                colors: ['transparent']
            },
            xaxis: {
                // @ts-ignore
                categories: prgModulesData === null || prgModulesData === void 0 ? void 0 : prgModulesData.map(e => (0, dateUtils_1.toDayMonth)(e.c_date)),
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                }
            },
            yaxis: {
                title: {
                    text: ''
                },
                stepSize: 20,
                min: 0,
                max: 100,
                labels: {
                    formatter: function (val) {
                        return val + "%";
                    }
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "% пройдено";
                    }
                }
            },
            annotations: {
                position: 'back',
                yaxis: [
                    {
                        label: {
                            text: " "
                        },
                        y: 10,
                        y2: 30,
                        fillColor: "rgba(248,83,74,0.4)",
                    },
                    {
                        label: {
                            text: " "
                        },
                        y: 30,
                        y2: 70,
                        fillColor: 'rgba(255,197,78,0.4)'
                    },
                    {
                        label: {
                            text: " "
                        },
                        y: 70,
                        y2: 90,
                        fillColor: 'rgba(58,183,71,0.4)'
                    },
                    {
                        label: {
                            text: " "
                        },
                        y: 90,
                        y2: 100,
                        fillColor: 'rgba(60,163,172,0.5)'
                    }
                ]
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Plate, { w: "60%", padding: "10px 0 0 0", style: { position: 'relative' }, className: 'plate-chart' },
            react_1.default.createElement(ChartSelect_1.ChartSelect, { options: modules === null || modules === void 0 ? void 0 : modules.map(key => ({ name: key, value: key })), style: { textTransform: 'capitalize' }, onChange: ev => setModuleKey(ev.target.value), value: moduleKey }),
            prgModules && react_1.default.createElement(react_apexcharts_1.default, { options: prgModulesState.options, series: prgModulesState.series, type: "bar", width: "450px", height: "200px" })),
        tooltipState.show && (react_1.default.createElement(CategoryHalfDonutsPopup_1.default, { ev: tooltipState, data: prgModulesData, closePopup: closeTooltip, setTargetExercise: setTargetExercise }))));
};
exports.default = ModulesColumns;
